import { useEffect, useRef } from "react";
import { createPlayer, type Player } from "../narrative/player";

export function useScriptedRun(autoStart = true) {
  const playerRef = useRef<Player | null>(null);

  useEffect(() => {
    playerRef.current = createPlayer();
    if (autoStart) {
      void playerRef.current.start();
    }

    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) return;
      if (!playerRef.current) return;
      if (e.key === "r" || e.key === "R") {
        e.preventDefault();
        void playerRef.current.replay();
      } else if (e.key === "s" || e.key === "S") {
        // single-key skip to handover
        e.preventDefault();
        playerRef.current.skip();
      } else if (e.key === "p" || e.key === "P" || e.key === " ") {
        // p / space — toggle pause/resume (shift+space still skips)
        e.preventDefault();
        if (e.key === " " && e.shiftKey) {
          playerRef.current.skip();
        } else if (playerRef.current.isPaused()) {
          playerRef.current.resume();
        } else {
          playerRef.current.pause();
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        playerRef.current.pause();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("keydown", onKey);
      playerRef.current?.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return playerRef;
}
